import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import React from "react";
import { Close, Search } from "@mui/icons-material";
import CancelIcon from "@mui/icons-material/Cancel";
import { Button, InputLabel } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import _ from 'lodash'

export const AllocationManager = ({
    selectedRow,
    IsActive,
    setIsActive,
    showAllocatedDepotName,
    showAllocatedDate,
    HandleAllocatedChecked,
    handleAllocateManagerClose,
    handleSubmitButtonOfAllocatedManager,
    showAllAllocateManagerUsers,
    allDepotPersonnelUsers,
    setShowAllAllocateManagersUsers,
    getAllData
}) => {

    /** redux store useDispatch & useSelector ------------------------------ **/
    const { depoPersonel } = useSelector((state) => state.depotUsers);

    /** hooks useState ----------------------------------------------------- **/
    const [searchValue, setSearchValue] = useState("");

    /** hooks useEffect----------------------------------------------------- **/
    useEffect(() => {
        let newData = ManipulatedData();
        if (IsActive) {
            const filteredIsActiveObject = _.filter(newData, (d1) => d1.isAllocated === false);
            setShowAllAllocateManagersUsers([...filteredIsActiveObject]);
        } else {
            let newData = getAllData(depoPersonel);
            setShowAllAllocateManagersUsers([...newData]);
        }
    }, [IsActive]);

    /** Function to manipulate data that needs to be shown in the allocate manager modal -------------------- **/
    const ManipulatedData = () => {
        return _.map(showAllAllocateManagerUsers, (d) => {
            let temp = { ...d };
            if (d.roles.includes("Admin")) {
                temp["isAdmin"] = true;
            } else {
                temp["isAdmin"] = false;
                let depots = _.filter(d?.depots || [], (d) => d.hasAllocated);
                if (depots.length > 0) {
                    temp["isAllocated"] = true;
                } else {
                    temp["isAllocated"] = false;
                }
            }
            return temp;
        });
    };

    /** Function executes when the user searches for depot users by first name or last name ----------------------- **/
    const handleSearchInputChange = (e) => {
        const searchText = e.target.value;
        setSearchValue(searchText);
        if (searchText === "") {
            const getOnlyDepotManagerUsers = _.filter(allDepotPersonnelUsers || [], (d) => {
                let filteredAllocatedDepots = _.filter(d?.depots || [], (d1) => d1.hasAllocated == true);
                const containsId = filteredAllocatedDepots.some(item => item.id === selectedRow?.id);
                if (!containsId) {
                    return d
                }
            }) || []
            setShowAllAllocateManagersUsers(getOnlyDepotManagerUsers);
        } else {
            const newFilter = showAllAllocateManagerUsers.filter((value) => {
                return (
                    value.firstName.toLowerCase().includes(searchText.toLowerCase()) ||
                    value.lastName.toLowerCase().includes(searchText.toLowerCase())
                );
            });
            setShowAllAllocateManagersUsers(newFilter);
        }
    };

    /** Function executes when clearing the search value. ----------------- **/
    const handleClearSearchText = () => {
        handleSearchInputChange({ target: { value: "" } });
    };


    return <div>
        <div className="depot-form-header-style">
            <span className="allocate-mgnr-header-color me-2">
                ALLOCATE MANAGER
            </span>
            <span className="allocate-mgnr-subheader-color">
                {selectedRow.name}
            </span>
        </div>
        <div style={{ marginTop: 40 }}>
            <div style={{ paddingLeft: 100, paddingRight: 100 }}>
                <div className="row">
                    <div className="col-md-4" style={{ position: "relative" }}>
                        <input
                            className="search-input-for-depot-personal-tab"
                            style={{ width: "100%" }}
                            value={searchValue}
                            type="text"
                            placeholder="Search by manager..."
                            onChange={handleSearchInputChange}
                        />
                        <div className="search-icon-allocate-mgnr-style">
                            {searchValue !== "" ? (
                                <Close
                                    style={{ cursor: "pointer", top: 0 }}
                                    onClick={handleClearSearchText}
                                />
                            ) : (
                                <Search style={{ top: 0 }} />
                            )}
                        </div>
                    </div>
                    <div className="col-md-8 d-flex justify-content-end">
                        <div className="d-flex align-items-center show-admin-checkbox">
                            <input
                                checked={IsActive}
                                type="checkbox"
                                onChange={({ target }) => setIsActive(target.checked)} style={{ marginTop: 10, marginRight: 15, width: 15, height: 15 }} />
                            <InputLabel>SHOW INACTIVE ONLY</InputLabel>
                        </div>
                    </div>
                </div>
                <div className="table-responsive allocate-mgnr-table">
                    <table className="table table-borderless">
                        <thead>
                            <tr>
                                <th>MANAGER</th>
                                <th>ALLOCATED TO</th>
                                <th>SINCE</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {showAllAllocateManagerUsers &&
                                showAllAllocateManagerUsers?.length > 0 ? (
                                showAllAllocateManagerUsers?.map((item, index) => {
                                    return (
                                        <React.Fragment key={index}>
                                            <tr>
                                                <td>
                                                    {item.firstName} {item.lastName}
                                                </td>
                                                <td className={`${showAllocatedDepotName(item) == "Inactive"
                                                    ? "added-red-border-for-depot"
                                                    : ""}`}>{showAllocatedDepotName(item)}</td>
                                                <td className="text-uppercase">
                                                    {showAllocatedDate(item)}{" "}
                                                </td>
                                                <td>
                                                    <input
                                                        checked={item.selected}
                                                        onChange={() =>
                                                            HandleAllocatedChecked(item.id)
                                                        }
                                                        style={{
                                                            width: 18,
                                                            height: 18,
                                                            cursor: "pointer",
                                                        }}
                                                        type="checkbox"
                                                    />
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td
                                        className="not-found-txt"
                                        colSpan="5"
                                        style={{ textAlign: "center" }}
                                    >
                                        No Records Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div
                    className="d-flex flex-row justify-content-between"
                    style={{ marginBottom: 20 }}
                >
                    <Button
                        variant="outlined"
                        className="btn-bootstrap-submit-style"
                        style={{ color: "red", borderColor: "red" }}
                        startIcon={<CancelIcon />}
                        onClick={() => {
                            setIsActive(null);
                            handleAllocateManagerClose()
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="outlined"
                        className="btn-bootstrap-submit-style"
                        startIcon={<CheckCircleIcon />}
                        type="submit"
                        onClick={handleSubmitButtonOfAllocatedManager}
                    >
                        Submit
                    </Button>
                </div>
            </div>
        </div>
    </div>
}